'use client';

import React, { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import { extractComponentFromChunk } from '@/ui/utils/tiles';
import Container from '../../shared/Container';

import 'swiper/css';
import 'swiper/css/pagination';
import './styles.css';

import OptimizedImage from '../../shared/OptimizedImage';
import { RichTextRenderer } from '../../tileRenderers/RichTextRenderer';
import { OneColumnSliderTile } from './types/OneColumnSliderTile';

export default function OneColumnSlider({ tile }: { tile: OneColumnSliderTile }) {
  const [currentIdx, setCurrentIdx] = useState(0);
  const currentTitle = extractComponentFromChunk(
    tile.cards.chunks[currentIdx],
    'title',
    'RichTextContent',
  );
  const currentDescription = extractComponentFromChunk(
    tile.cards.chunks[currentIdx],
    'description',
    'RichTextContent',
  );
  return (
    <Container>
      <Swiper
        slidesPerView={1}
        spaceBetween={10}
        modules={[Pagination]}
        pagination={{
          clickable: true,
        }}
        className="one-col-slider h-xs w-full md:h-md xl:h-lg"
        onSlideChange={(swiper) => setCurrentIdx(swiper.activeIndex)}
      >
        {tile.cards.chunks.map((card, i) => {
          const image = extractComponentFromChunk(card, 'image', 'ImageContent');
          const title = extractComponentFromChunk(card, 'title', 'RichTextContent');
          const description = extractComponentFromChunk(card, 'description', 'RichTextContent');
          return (
            <SwiperSlide
              key={`${i}one-col-slider`}
              className="group relative z-0 overflow-hidden rounded-xl"
            >
              <OptimizedImage
                imageComponent={image}
                fill
                className="-z-20 object-cover"
                sizes="100vw"
              />
              <div className=" absolute inset-0 -z-10 bg-gradient-middle" />
              <div className=" flex h-full w-full items-center justify-center text-white">
                <div className="hidden space-y-2 text-center sm:block">
                  <RichTextRenderer
                    blocks={title}
                    className="sm:text-3xl md:text-4xl lg:text-5xl"
                  />
                  <RichTextRenderer blocks={description} className="md:text-xl lg:text-2xl" />
                </div>
              </div>
            </SwiperSlide>
          );
        })}
      </Swiper>
      <div className="text-center sm:hidden">
        <RichTextRenderer blocks={currentTitle} className="text-3xl" />
        <RichTextRenderer blocks={currentDescription} className="text-md" />
      </div>
    </Container>
  );
}
